var _excluded = ["schema", "onSubmit", "isSaving", "isLoading", "onSubmissionStateChange", "subscribeToDefaultValuesChanges", "showOptionalIndicator"],
    _excluded2 = ["defaultValues"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line import/no-extraneous-dependencies
import { yupResolver } from '@hookform/resolvers/yup';
import { defaults } from 'lodash';
import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { getFieldError, isFieldRequiredBySchema } from './useMelioForm.utils';
var defaultProps = {
  criteriaMode: 'all',
  reValidateMode: 'onChange',
  mode: 'onSubmit',
  defaultValues: {}
};
var defaultFormProps = {
  autoComplete: 'off' // We must use a valid value for a11y reasons

};

function createDefaultValue(type) {
  switch (type) {
    case 'number':
      return 0;

    case 'string':
      return '';

    case 'boolean':
      return false;
  }

  return void 0;
}

export var useMelioForm = _ref => {
  var {
    schema,
    onSubmit,
    isSaving,
    isLoading,
    onSubmissionStateChange,
    subscribeToDefaultValuesChanges,
    showOptionalIndicator
  } = _ref,
      _props = _objectWithoutProperties(_ref, _excluded);

  var _defaults = defaults(_props, defaultProps),
      {
    defaultValues
  } = _defaults,
      props = _objectWithoutProperties(_defaults, _excluded2);

  var useFormResults = useForm(_objectSpread(_objectSpread({
    resolver: schema && yupResolver(schema)
  }, props), {}, {
    // TODO: https://meliorisk.atlassian.net/browse/ME-385
    defaultValues: _objectSpread(_objectSpread({}, Object.entries((schema === null || schema === void 0 ? void 0 : schema.fields) || {}).reduce((memo, _ref2) => {
      var [key, schema] = _ref2;
      return _objectSpread(_objectSpread({}, memo), {}, {
        [key]: createDefaultValue(schema.type)
      });
    }, {})), defaultValues)
  }));
  var inputRef = useRef(null);
  var {
    isValid,
    errors
  } = useFormResults.formState; // The form button is always enabled when validating on submit

  var isSubmittable = (props.mode == 'onSubmit' || isValid) && !isLoading;

  var formProps = _objectSpread(_objectSpread({}, defaultFormProps), {}, {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onSubmit: useFormResults.handleSubmit((data, event) => {
      var _inputRef$current, _inputRef$current2;

      onSubmit(data, event, (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.dataset['target']);
      if ((_inputRef$current2 = inputRef.current) !== null && _inputRef$current2 !== void 0 && _inputRef$current2.dataset['target']) delete inputRef.current.dataset['target'];
    }),
    inputRef,
    isReadOnly: isSaving || isLoading,
    isLoading
  });

  var registerField = fieldName => ({
    error: getFieldError(fieldName, errors),
    control: useFormResults.control,
    name: fieldName,
    id: fieldName,
    isRequired: schema ? isFieldRequiredBySchema(fieldName, schema) : false,
    showOptionalIndicator
  });

  var handleSubmit = target => () => {
    var _inputRef$current3;

    if (target && inputRef.current) inputRef.current.dataset['target'] = target;
    (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.click();
  };

  var results = _objectSpread(_objectSpread({}, useFormResults), {}, {
    registerField,
    formProps,
    handleSubmit,
    submitButtonProps: {
      onClick: handleSubmit(),
      isDisabled: !isSubmittable,
      isLoading: isSaving
    },
    cancelButtonProps: {
      isDisabled: isSaving
    }
  });

  useEffect(() => {
    onSubmissionStateChange === null || onSubmissionStateChange === void 0 ? void 0 : onSubmissionStateChange(results); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmittable, isSaving, isValid, isLoading]);
  useDeepCompareEffect(() => {
    if (subscribeToDefaultValuesChanges) {
      useFormResults.reset(defaultValues);
    }
  }, [defaultValues, subscribeToDefaultValuesChanges]);
  return results;
};
//# sourceMappingURL=useMelioForm.js.map